import axios from 'axios';

export default {
  get: (params) => axios.get('/api/v1/content', { params }),
  getById: (id) => axios.get(`/api/v1/content/${id}`),
  getItemsById: (id, params) => axios.get(`/api/v1/content/${id}/items`, { params }),
  removeItem: (id, itemId) => axios.delete(`/api/v1/content/${id}/items/${itemId}`),
  removeAllItems: (id, itemId) => axios.delete(`/api/v1/content/${id}/items`),
  createItem: (id, params) => axios.post(`/api/v1/content/${id}/items`, params),
  updateItem: (id, itemId, params) => axios.put(`/api/v1/content/${id}/items/${itemId}`, params),
  remove: (id, itemId) => axios.delete(`/api/v1/content/${id}`),
  create: (params) => axios.post('/api/v1/content', params),
  update: (params) => axios.put(`/api/v1/content/${params.id}`, params),
};
